export default __webpack_public_path__ + "static/dorothy-9dde3468f868aa54a3c75367f73c44c3.png";